// Automatically generated based off models.kt
@file:OptIn(ExperimentalSerializationApi::class, InternalSerializationApi::class)
@file:Suppress("UnusedImport", "UNCHECKED_CAST")

package com.ilussobsa

import com.lightningkite.*
import com.lightningkite.Length.Companion.miles
import com.lightningkite.lightningdb.*
import com.lightningkite.lightningserver.files.*
import com.lightningkite.serialization.*
import kotlin.jvm.JvmInline
import kotlin.math.roundToInt
import kotlin.time.Duration.Companion.seconds
import kotlinx.datetime.*
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi
import com.lightningkite.serialization.DataClassPath
import com.lightningkite.serialization.DataClassPathSelf
import com.lightningkite.serialization.SerializableProperty
import kotlin.reflect.*
import kotlinx.serialization.*
import kotlinx.serialization.builtins.*
import kotlinx.serialization.internal.GeneratedSerializer

// Contextual types: kotlinx.datetime.Instant, com.lightningkite.UUID, com.lightningkite.lightningserver.files.ServerFile, kotlinx.datetime.LocalDate
fun prepareFinancingApplicationFields() {
    val props: Array<SerializableProperty<FinancingApplication, *>> = arrayOf(FinancingApplication__id, FinancingApplication_user, FinancingApplication_at, FinancingApplication_primary, FinancingApplication_secondary, FinancingApplication_additionalInformation)
    FinancingApplication.serializer().properties { props }
}
val <K> DataClassPath<K, FinancingApplication>._id: DataClassPath<K, UUID> get() = this[FinancingApplication__id]
val <K> DataClassPath<K, FinancingApplication>.user: DataClassPath<K, UUID> get() = this[FinancingApplication_user]
val <K> DataClassPath<K, FinancingApplication>.at: DataClassPath<K, Instant> get() = this[FinancingApplication_at]
val <K> DataClassPath<K, FinancingApplication>.primary: DataClassPath<K, FinancingApplicant> get() = this[FinancingApplication_primary]
val <K> DataClassPath<K, FinancingApplication>.secondary: DataClassPath<K, FinancingApplicant?> get() = this[FinancingApplication_secondary]
val <K> DataClassPath<K, FinancingApplication>.additionalInformation: DataClassPath<K, String?> get() = this[FinancingApplication_additionalInformation]
inline val FinancingApplication.Companion.path: DataClassPath<FinancingApplication, FinancingApplication> get() = path<FinancingApplication>()


object FinancingApplication__id: SerializableProperty<FinancingApplication, UUID> {
    override val name: String by lazy { FinancingApplication.serializer().descriptor.getElementName(0) }
    override fun get(receiver: FinancingApplication): UUID = receiver._id
    override fun setCopy(receiver: FinancingApplication, value: UUID) = receiver.copy(_id = value)
    override val serializer: KSerializer<UUID> by lazy { (FinancingApplication.serializer() as GeneratedSerializer<*>).childSerializers()[0] as KSerializer<UUID> }
    override val annotations: List<Annotation> by lazy { FinancingApplication.serializer().descriptor.getElementAnnotations(0) }
    override val default: UUID = UUID.random()
    override val defaultCode: String? = "UUID.random()" 
}
object FinancingApplication_user: SerializableProperty<FinancingApplication, UUID> {
    override val name: String by lazy { FinancingApplication.serializer().descriptor.getElementName(1) }
    override fun get(receiver: FinancingApplication): UUID = receiver.user
    override fun setCopy(receiver: FinancingApplication, value: UUID) = receiver.copy(user = value)
    override val serializer: KSerializer<UUID> by lazy { (FinancingApplication.serializer() as GeneratedSerializer<*>).childSerializers()[1] as KSerializer<UUID> }
    override val annotations: List<Annotation> by lazy { FinancingApplication.serializer().descriptor.getElementAnnotations(1) }
}
object FinancingApplication_at: SerializableProperty<FinancingApplication, Instant> {
    override val name: String by lazy { FinancingApplication.serializer().descriptor.getElementName(2) }
    override fun get(receiver: FinancingApplication): Instant = receiver.at
    override fun setCopy(receiver: FinancingApplication, value: Instant) = receiver.copy(at = value)
    override val serializer: KSerializer<Instant> by lazy { (FinancingApplication.serializer() as GeneratedSerializer<*>).childSerializers()[2] as KSerializer<Instant> }
    override val annotations: List<Annotation> by lazy { FinancingApplication.serializer().descriptor.getElementAnnotations(2) }
    override val default: Instant = now()
    override val defaultCode: String? = "now()" 
}
object FinancingApplication_primary: SerializableProperty<FinancingApplication, FinancingApplicant> {
    override val name: String by lazy { FinancingApplication.serializer().descriptor.getElementName(3) }
    override fun get(receiver: FinancingApplication): FinancingApplicant = receiver.primary
    override fun setCopy(receiver: FinancingApplication, value: FinancingApplicant) = receiver.copy(primary = value)
    override val serializer: KSerializer<FinancingApplicant> by lazy { (FinancingApplication.serializer() as GeneratedSerializer<*>).childSerializers()[3] as KSerializer<FinancingApplicant> }
    override val annotations: List<Annotation> by lazy { FinancingApplication.serializer().descriptor.getElementAnnotations(3) }
}
object FinancingApplication_secondary: SerializableProperty<FinancingApplication, FinancingApplicant?> {
    override val name: String by lazy { FinancingApplication.serializer().descriptor.getElementName(4) }
    override fun get(receiver: FinancingApplication): FinancingApplicant? = receiver.secondary
    override fun setCopy(receiver: FinancingApplication, value: FinancingApplicant?) = receiver.copy(secondary = value)
    override val serializer: KSerializer<FinancingApplicant?> by lazy { (FinancingApplication.serializer() as GeneratedSerializer<*>).childSerializers()[4] as KSerializer<FinancingApplicant?> }
    override val annotations: List<Annotation> by lazy { FinancingApplication.serializer().descriptor.getElementAnnotations(4) }
    override val default: FinancingApplicant? = null
    override val defaultCode: String? = "null" 
}
object FinancingApplication_additionalInformation: SerializableProperty<FinancingApplication, String?> {
    override val name: String by lazy { FinancingApplication.serializer().descriptor.getElementName(5) }
    override fun get(receiver: FinancingApplication): String? = receiver.additionalInformation
    override fun setCopy(receiver: FinancingApplication, value: String?) = receiver.copy(additionalInformation = value)
    override val serializer: KSerializer<String?> by lazy { (FinancingApplication.serializer() as GeneratedSerializer<*>).childSerializers()[5] as KSerializer<String?> }
    override val annotations: List<Annotation> by lazy { FinancingApplication.serializer().descriptor.getElementAnnotations(5) }
    override val default: String? = null
    override val defaultCode: String? = "null" 
}
